export function status(state) {
  return state.status;
}

export function notify(state) {
  return state.notify;
}

export function banks(state) {
  return state.bank;
}

export function stats(state) {
  return state.stats;
}

export function modals(state) {
  return state.modals;
}